import { isDevSettingsEnabled } from "@app-composables/settings";
import { ref } from "vue";

declare global {
	interface Window {
		openDevSettings?: () => void;
		devSettingsOpenRequested?: boolean;
	}
}

const FALLBACK_DIALOG_ID = "dev-settings-fallback";
const URL_PARAM = "openDevSettings";

// Module-level: usable before the app is mounted.
export const debugDialogIsOpen = ref(false);

function openDialog() {
	debugDialogIsOpen.value = true;
}

// Also covers deployed builds, where the standalone bootstrap is not injected.
function consumeUrlParam() {
	const url = new URL(location.href);
	if (!url.searchParams.has(URL_PARAM)) return false;

	url.searchParams.delete(URL_PARAM);
	history.replaceState(history.state, "", url);
	return true;
}

// Runs on import: the router keeps the URL it finds when it is created.
const openRequestedByUrl = consumeUrlParam();

// Called from boot; keeps the standalone openDevSettings() if there is one.
function exposeOpenDevSettings() {
	if (!isDevSettingsEnabled()) return;

	if (!window.openDevSettings) window.openDevSettings = openDialog;
	if (openRequestedByUrl) openDialog();
}

// Called when the dialog is mounted: the real dialog takes over.
function takeOverOpenDevSettings() {
	if (!isDevSettingsEnabled()) return;

	window.openDevSettings = openDialog;
	const standalone = document.getElementById(FALLBACK_DIALOG_ID);
	standalone?.remove();
	if (standalone || window.devSettingsOpenRequested) {
		delete window.devSettingsOpenRequested;
		openDialog();
	}
}

export default function useDebugDialog() {
	return { debugDialogIsOpen, exposeOpenDevSettings, takeOverOpenDevSettings };
}
